import CAbnormal from '@components/c-abnormal';
import {Component} from '@src/lib/San';
import CSugRecommend from '../../../../components/chat/c-sug-recommend';
import {getChatInfo} from '../../service/index';
import $style from './index.module.less';

export default class App extends Component {
    static template = /* html */`
        <div>
            <div class="{{$style.errorBox}}">
                <div class="{{$style.errorImg}}">
                </div>
                <div class="{{$style.errorTip}}">
                    抱歉，该服务已下线
                </div>
                <div
                    class="{{$style.errorBtn}}"
                    on-click="invokeApp"
                >
                    打开APP
                </div>
            </div>
            <div s-if="sugBotsData" class="{{$style.recommend}}">
                <div class="{{$style.recommendTitle}}">
                    - APP内更多工具等你发现 -
                </div>

                <c-sug-recommend
                    s-if="sugBotsData.sugBots && sugBotsData.sugBots.length > 0"
                    sug-bots="{{sugBotsData.sugBots}}"
                    need-log="{{false}}"
                />
            </div>
        </div>
    `;

    static components = {
        'c-abnormal': CAbnormal,
        'c-sug-recommend': CSugRecommend,
    };

    initData() {
        return {
            $style,
        };
    }

    created() {
        this.getPageInfo();
    }

    async getPageInfo() {
        const params = {};
        const res: any = await getChatInfo(params);

        if (res?.errno === 0 && res.data) {
            const {sugRec} = res.data;
            this.data.set('sugBotsData', sugRec);

            window.liteChatInfo = window.liteChatInfo || {};
            window.liteChatInfo.sugBotsData = {
                sugTitle: sugRec?.title,
                sutBots: sugRec?.sugBots,
                sugType: sugRec?.type,
            };
        }
        else {
            this.data.set('sugBotsData', {
                sutBots: [],
            });
        }
    }

    invokeApp() {
        this.fire('invoke-app');
    }
}
